export default {"src":"/_next/static/media/twitter.3cb26dc1.svg","height":24,"width":24};